<template>
  <div id="back-play">
    <!-- 头 -->
    <div class="top">
      <div class="go_back cursor" @click="go_back()"></div>
      <p>
        {{ playbackData.title }} {{ playbackData.begin_time.split(" ")[0] }}
      </p>
      <img
        class="cursor"
        ondragstart="return false;"
        @click.stop="toggoleProtect(true)"
        :src="
          openEye
            ? 'static/img/playback/eye_open.png'
            : 'static/img/playback/eye_close.png'
        "
      />
    </div>
    <div class="video_box" @click="clickVideo">
      <div
        class="play_video"
        :style="{ width: videoWH.w + 'px', height: videoWH.h + 'px' }"
      >
        <i class="close_question cursor" v-show="closeQuestionShow" @click="closeQuestion"></i>
        <kejian
          @closeIframe="closeQuestion"
          @loadGameSuccess='loadGameSuccess=true'
          :subType="kejianQuestionSubType"
          :type="kejianQuestionType"
          :iframeQuickId="iframeQuickId"
          :gameName="gameName"
          :questionids="questionids"
          :topicType="2"
          ref="kejian"
          @click.native="clickVideo"
          :preClassTestBgImage="preClassTestBgImage"
          style="pointer-events: none;"
        />
        <video
          crossOrigin="anonymous"
          v-if="videoShow"
          :src="playbackData.play_back_url"
          class="video"
          :width="videoWH.w"
          :height="videoWH.h"
          id="video"
          ref="video"
          @ended="playend"
          @contextmenu.prevent
        ></video>
      </div>
    </div>
    <div
      class="bottom"
      @mouseenter="bottomShow = true"
      @mousemove="bottomShowFn"
      @mouseleave="bottomShow = false"
    >
      <transition name="fade">
        <div class="bottom_sub" v-show="bottomShow && questionEndTime===-1" @click.stop>
          <div class="bottom_cont">
            <img
              class="play-toggle cursor"
              @click="togglePlay"
              :src="playFlag ? '/static/img/playback/play.png':'/static/img/playback/pause.png'"
              alt
            />
            <span class="video-currentTime">{{ currentTime | time }}</span>
            <div class="input_box">
              <i
                class="cursor"
                :class="{ i_active: currentTime >= Number(v.time) }"
                v-for="(v, i) in playbackData.playback_url_tag"
                :key="i"
                :style="{
                  left: 'calc(' + (v.time / duration || 0) * 100 + '% + 6px)',
                }"
              >
                <em>
                  {{ v.tag }}
                  <img
                    @click="clickVideoTag({ v, i })"
                    src="../../../assets/img/common/play.png"
                  />
                </em>
              </i>
              <input
                class="range"
                type="range"
                @change="range"
                @mousedown="rangeMousedown"
                @mouseup="rangeMouseup"
                v-model="currentTime"
                :max="duration"
                ref="range"
                min="0"
                step="1"
                :style="{
                  backgroundSize:
                    (currentTime / duration || 0) * 100 + '% 100%',
                }"
              />
            </div>
            <span class="video-duration">{{ duration | time }}</span>
            <span class="rate cursor" @click="clickTagSwitch(3)">{{
              `${rateArr[rateIndex]}X`
            }}</span>
            <img
              v-if="!issafariBrowser"
              class="screenshots cursor"
              src="static/img/playback/screenshots.png"
              @click="screenshots()"
              alt
            />
            <img
              class="vp-tap cursor"
              src="/static/img/playback/tagList.png"
              @click="clickTagSwitch(2)"
              alt
            />
          </div>
        </div>
      </transition>
    </div>
    <transition :name="timu_message.type==='xuanze'?'xz':'tk'">
      <answer
        style="pointer-events: none;"
        v-show="a_on_off"
        :a_on_off="a_on_off"
        :datas="timu_message"
      />
    </transition>
    <slide
      :showExeriseList="showExeriseList"
      :tagIndex="tagIndex"
      @clickVideoTag="clickVideoTag"
      @changeRate="changeRate"
      @clickTagSwitch="clickTagSwitch"
      :rateIndex="rateIndex"
      :rateArr="rateArr"
      :playbackData="playbackData"
    ></slide>
    <!-- loading -->
    <loading v-show="loadState === 'loading'" />
    <loaderr
      v-show="loadState === 'loaderr'"
      @loadvideo="loadAgain"
      loadErrText="加载失败，请点击按钮重新加载~"
    />
    <!-- 设备错误 -->
    <alert
      :show="showAlert"
      :sameOne="'您的设备播放课程出现异常请联系学管老师'"
      :cancal="'我知道了'"
      @cancelEvent="showAlert = false"
    />
    <Toast
      :showText="showText"
      :waitTime="3000"
      v-if="showText"
      @toastCallBack="showText = ''"
    />
    <Tips v-if="answerTipsShow" @close="answerTipsShow = false"></Tips>
  </div>
</template>
<script>
import common from "common";
import alert from "@/components/basic/alert.vue";
import utils from "@/js/utils.js";
import { mapState, mapActions, mapMutations } from "vuex";
import Toast from "../../basic/toast"; //Toast
import Tips from "./tips.vue";
import slide from "./slide.vue";
import loading from "@/components/basic/videoloading";
import loaderr from "../video/loaderr.vue"; //视频加载失败
import answerJs from "../video/answer/answer.js";
import answer from "../video/answer/answer.vue";
import kejian from "../video/answer/kejian.vue";
export default {
  name: "playback",
  mixins: [answerJs],
  data() {
    return {
      videoWH:utils.setVideoWH(96),
      video: null,
      showExeriseList: 1, //展开练习列表，
      tagIndex: -1, //当前播放到位置信息
      showAlert: false, //超时提示框
      loadState: "loading", //是否显示Loading
      isShowSidebarMask: false, //练习列表展示的时候是否要在视频区域显示蒙层
      bottomShow: true,
      videoShow: true,
      videoLoad: true, //视频第一次加载
      bottomInterval: null,
      playFlag: false, //是否正在播放
      duration: 0, //视频总长
      currentTime: 0, //视频当前时间
      isDrag: false,
      openEye: false,
      timer: null,
      rateIndex: 3,
      rateArr: ["2.0", "1.5", "1.25", "1.0", "0.8"],
      temp_unique_id: Date.now(),
      issafariBrowser: utils.issafariBrowser(),
      onlineTime: 0,
      showText: "",
      loadInterval: null, //十秒加载失败计时器
      sendLogData: {}, //发题日志
      answerTipsShow: false, //答题提示
      questionEndTime: -1, //题目关闭时间
      questionStartTime: -1, //题目开始展示时间
      currentKey: -1,
      sendTestInterval:null,//定时发送课前测计时器
      closeQuestionShow:false,//关闭题目按钮是否展示
    };
  },
  components: {
    loading,
    alert,
    Toast,
    slide,
    loaderr,
    answer,
    kejian,
    Tips
  },
  mounted() {
    const eyeMode = LIMI_ENV === "electron" ? utils.getNodeStorge("eyeMode") : common.get("eyeMode");
    if (eyeMode) {
      this.toggoleProtect(false);
    }
    this.getLog();
    this.bottomShowFn();
    this.uploadOnlineTime();
    this.initVideo();
  },
  computed: {
    ...mapState([
      "playbackData",
      "video_replay_time",
      "smallClassId",
      "count_online_time_interval",
      "lesson_type",
      "lesson_id",
      "class_id",
      "userID",
      "playbackQuestionTime",
      "video_stream_load_timeout"
    ]),
    //起始的播放时间：如果有节点，直接跳过开始的那个段时间
    videoBegin() {
      return this.playbackData.playback_url_tag[0]
        ? this.playbackData.playback_url_tag[0]
        : {};
    },
    //每个节点对应的播放时间段
    videoTagTimeArr() {
      let temp = this.playbackData.playback_url_tag;
      let time_length = this.playbackData.time_length;
      let arr = [];
      if (!!temp) {
        arr = temp.map((v) => v.time);
        arr.push(time_length);
      }
      return arr;
    },
  },
  methods: {
    ...mapActions(["durationRport", "getPlaybackSendLog"]),
    ...mapMutations(["savePlaybackData"]),
    initVideo() {
      this.video = this.$refs.video;
      if (!this.video) return;
      window.onresize = ()=>{
        this.videoWH = utils.setVideoWH(96)
      };
      this.loadInterval = setTimeout(this.videoError, this.video_stream_load_timeout * 1000);
      this.video.oncanplay = () => {
        if (!this.videoLoad) return;
        this.videoLoad = false;
        let durationTime = parseInt(this.video.duration);
        let srvTime = parseInt(this.playbackData.time_length);
        let videotime = Math.abs(srvTime - durationTime);
        this.loadState = "";
        clearTimeout(this.loadInterval);
        if (
          this.video_replay_time != 0 &&
          videotime >= this.video_replay_time
        ) {
          this.showAlert = true;
          this.videoShow = false;
          this.video = null;
          return;
        }
        this.playChapter(this.videoBegin.time);
        this.duration = this.video.duration;
      };
      this.video.addEventListener("timeupdate", this.videoTimeupdate);
      this.video.removeEventListener("error", this.videoError);
      this.video.removeEventListener("waiting", this.videoWaiting);
    },
    playend() {
      this.video.currentTime = this.duration;
      this.video.pause();
      this.playFlag = false;
      this.closeQuestion();
    },
    videoTimeupdate() {
      //使用事件监听方式捕捉事件
      const timeDisplay = Math.floor(this.video.currentTime);
      if (this.currentTime != timeDisplay) {
        this.loadState = "";
      }
      if ((timeDisplay >= this.questionEndTime || timeDisplay < this.questionStartTime) && this.questionEndTime !== -1) {
        // console.log('关闭题目',this.questionEndTime);
        clearInterval(this.sendTestInterval);
        this.closeQuestion();
      }
      if (this.currentTime == timeDisplay && this.currentKey == this.currentTime) return;
      if (!this.isDrag) {
        this.currentTime = timeDisplay;
        this.uploadEffectiveOnlineTime();
      }
      if (this.sendLogData[this.currentTime - 1] && !this.isDrag) {
        // console.log('展示题目时间',this.currentTime)
        clearInterval(this.sendTestInterval);
        this.currentKey = this.currentTime;
        this.showQuestion(this.currentTime);
      } else {
        this.currentKey = -1; //为了解决第一次播放时间点有题不展示问题
      }
      this.tagListChecked(timeDisplay);
    },
    videoWaiting() {
      // console.log('卡顿------')
      this.loadState = "loading";
    },
    videoError() {
      this.loadState = "loaderr";
      this.video && this.video.pause();
      this.playFlag = false;
    },
    closeQuestion() {
      this.answerTipsShow = false;
      this.a_on_off = false;
      this.timu_message = {};
      this.iframeQuickId = ""; //课件题
      this.gameName = ""; //小游戏
      this.loadGameSuccess = false; //小游戏加载成功标记
      this.questionids = "";
      this.questionEndTime = -1;
      this.questionStartTime = -1;
      this.closeQuestionShow = false;
      this.removeTestData();
    },
    //删除课前测缓存数据
    removeTestData(){
      const frontTest = common.get('frontTest') || [];
      frontTest.forEach((v,i)=>{
        if(v.lesson_id==this.lesson_id){
          frontTest.splice(i,1);
        }
      })
      common.set('frontTest',frontTest)
    },
    //答题区域显示隐藏的方法
    showQuestion(ctime) {
      const key = ctime - 1;
      const type = this.sendLogData[key].qtype;
      const qid =  this.sendLogData[key].quickQuestionId;
      const datas = {
        unique_id: " ",
        data: {
          quick_question_id:qid,
          type: type,
          srv_time:common.getTemServerTime()
        }
      };
      let len = 1;
      if(type==5 && this.quickData[qid]){
        let arr =  this.quickData[qid].question_ids.split(",")
        len = arr.length;
        this.sendTestInterval = setInterval(()=>{
          arr.shift();
          if(arr.length===0){
            clearInterval(this.sendTestInterval);
            return;
          }
          const frontTest = common.get('frontTest');
          const index = frontTest.findIndex((v)=>{
            return v.qid==this.currentQuestion
          })
          const index1 = frontTest[index].qdata.findIndex((v)=>{
            return v.qid==arr[0]
          })
          frontTest[index].qdata[index1-1].status=1
          common.set('frontTest',frontTest)
          this.$root.eventHub.$emit("autoTurnPage",{id:qid});
        },this.playbackQuestionTime / this.rateArr[this.rateIndex] * 1000)
      }
      this.$root.eventHub.$emit("question", datas, "");
      this.showExeriseList = 1;
      this.bottomShow = false;
      this.questionEndTime = ctime + this.playbackQuestionTime * len;
      this.questionStartTime = ctime;
      setTimeout(()=>{
        if(this.quickData[qid] || this.standardData[qid]) this.closeQuestionShow = true;
      },1200)
    },
    tagListChecked(timeDisplay) {
      let tagArr = this.videoTagTimeArr;
      let len = tagArr.length;
      if (len) {
        tagArr.forEach((v, i, s) => {
          if (timeDisplay >= v) {
            this.tagIndex = i;
          }
          if (i === 0 && timeDisplay < v) {
            this.tagIndex = -1;
          }
          if (i === len - 1 && timeDisplay > s[len - 2]) {
            this.tagIndex = len - 2;
          }
        });
      }
    },
    //从新加载视频
    loadAgain() {
      this.loadState = "loading";
      this.videoFirstLoad = true;
      this.video && this.video.load();
      this.togglePlay();
      this.loadInterval = setTimeout(this.videoError, this.video_stream_load_timeout * 1000);
    },
    range() {
      this.playChapter(this.currentTime);
      this.bottomShow = false;
    },
    rangeMousedown() {
      clearTimeout(this.bottomInterval);
      this.isDrag = true;
    },
    rangeMouseup() {
      this.isDrag = false;
    },
    bottomShowFn() {
      clearTimeout(this.bottomInterval);
      if (this.bottomShow && !this.isDrag) {
        this.bottomInterval = setTimeout(() => {
          this.bottomShow = false;
        }, 5000);
      }
    },
    //=>切换视频播放暂停
    togglePlay() {
      if (this.video.paused) {
        if (this.currentTime >= Math.floor(this.duration)) {
          this.video.currentTime = 0;
        }
        this.video.play();
        this.playFlag = true;
        this.bottomShow = false;
        return;
      }
      this.playFlag = false;
      this.video.pause();
    },
    //根据时间切换视频播放
    playChapter(time = 0) {
      this.video.currentTime = time;
      this.video.play();
      this.playFlag = !this.video.paused;
    },
    //点击返回上一级
    go_back() {
      this.$router.push({
        name: "course",
      });
    },
    //显示隐藏题目列表
    clickTagSwitch(type) {
      this.showExeriseList = type;
    },
    //点击题目切换到对应的题目讲解
    clickVideoTag({ v, i }) {
      this.tagIndex = i;
      this.playChapter(v.time);
      this.clickTagSwitch(1);
      this.bottomShow = false;
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventPlayBackTag",
        data: {
          name: v.tag,
          index: i + 1,
        },
      });
    },
    //更改倍速
    changeRate({ v, i }) {
      this.video.playbackRate = v;
      this.rateIndex = i;
      this.clickTagSwitch(1);
    },
    //点击mask隐藏视频分段列表和mask
    clickVideo() {
      if(this.questionStartTime!==-1){
        this.answerTipsShow = true;
        return;
      }
      this.showExeriseList = 1;
    },
    //截图
    screenshots() {
      this.bottomShow = false;
      this.showText = "";
      if (LIMI_ENV === "electron") {
        utils.screenshotsPc((res) => {
          if (res === "success") {
            this.showText = "截图已保存到桌面";
            this.$root.eventHub.$emit("createLog", {
              id: "LMTrackEventScreeCapture",
              data: {
                pageType: 2
              },
            });
          }
        });
      } else {
        utils.downloadScreenshotsWeb();
        this.$root.eventHub.$emit("createLog", {
          id: "LMTrackEventScreeCapture",
          data: {
            pageType: 2
          },
        });
      }
    },
    toggoleProtect(needToast) {
      this.openEye = !this.openEye;
      this.$root.eventHub.$emit("toggoleProtect", {
        openEye: this.openEye,
        needToast,
      });
    },
    //大数据埋点上报
    uploadOnlineTime() {
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventVideoPage_start",
        data: {
          lesson_type: this.playbackData.lesson_type,
          unique_id: this.temp_unique_id,
          small_class_id: this.smallClassId,
        },
      });
      //上报观看回放时间
      this.timer = setInterval(() => {
        !this.video.paused &&
          this.$root.eventHub.$emit("createLog", {
            id: "LMTrackEventViewingTime",
            data: {
              lesson_type: this.playbackData.lesson_type,
              unit: this.count_online_time_interval,
            },
          });
      }, 1000 * this.count_online_time_interval);
    },
    //上报有效的观看回放
    uploadEffectiveOnlineTime() {
      this.onlineTime++;
      if (
        this.onlineTime >= this.count_online_time_interval &&
        document.visibilityState === "visible"
      ) {
        this.onlineTime = 0;
        let type = 2;
        if (this.lesson_type == 1 || this.lesson_type == 5) {
          type = 3;
        }
        if (this.lesson_type == 3 || this.lesson_type == 6) {
          type = 2;
        }
        const sendData = {
          time: common.getTemServerTime(),
          event: 2001,
          data: {
            class_id: this.class_id,
            lesson_id: this.lesson_id,
            student_id: this.userID,
            type: type,
            length: this.currentTime,
          },
        };
        this.durationRport(sendData);
      }
    },
    //获取发题日志
    getLog() {
      this.getPlaybackSendLog({
        lessonId: this.lesson_id
      }).then(({res,ok})=>{
        if(ok){
          this.sendLogData = res;
        }
      })
    },
  },
  watch: {
    bottomShow() {
      this.bottomShowFn();
    },
  },
  destroyed() {
    clearInterval(this.timer);
    clearInterval(this.sendTestInterval);
    this.removeTestData();
    window.onresize = null;
    if (this.video) {
      this.video.src = "";
      this.video.removeEventListener("timeupdate", this.videoTimeupdate);
      this.video.removeEventListener("error", this.videoError);
      this.video.removeEventListener("waiting", this.videoWaiting);
    }
    this.$root.eventHub.$emit("createLog", {
      id: "LMTrackEventVideoPage_end",
      data: {
        lesson_type: this.playbackData.lesson_type,
        unique_id: this.temp_unique_id,
        small_class_id: this.smallClassId,
      },
    });
    this.savePlaybackData({});
  },
};
</script>
<style lang="less" rel="stylesheet/less" scoped>
#back-play {
  text-align: center;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  position: relative;
  background: #000000;
  overflow: hidden;
}
.top {
  position: relative;
  z-index: 99;
  height: 96px;
  width: 100%;
  background: #000000;
  text-align: center;
  p {
    font-size: 31px;
    color: #ffffff;
    line-height: 96px;
    text-shadow: 0 0 12px rgba(0, 0, 0, 0.5);
    font-family: PingFang_Medium;
  }
  .go_back {
    position: absolute;
    height: 56px;
    width: 56px;
    left: 30px;
    top: 20px;
    background: url(../../../assets/img/common/back.png) left center no-repeat;
    background-size: 100% 100%;
    z-index: 3;
  }
  img {
    position: absolute;
    width: 56px;
    height: 56px;
    right: 30px;
    top: 21px;
  }
}
.video_box {
  width: 100%;
  height: calc(100% - 96px);
  display: flex;
  align-items: center;
  justify-content: center;
}
.play_video{
  position: relative;
}
.close_question{
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 99;
  width: 90px;
  height: 36px;
  background: url('/static/img/playback/close_question.png') no-repeat;
  background-size:cover;
}
.bottom {
  width: 100%;
  height: 96px;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 99;
}
.bottom_sub {
  width: 100%;
  height: 96px;
  background: #000000;
  .bottom_cont {
    width: 100%;
    display: flex;
    height: 40px;
    padding-top: 20px;
    align-items: center;
  }
  .play-toggle {
    float: left;
    margin: 5px 0 0 27px;
    text-align: left;
    width: 20px;
    height: 23px;
    margin-top: -5px;
  }
  .input_box {
    flex: 1;
    margin: 0 40px 0 15px;
    position: relative;
    i {
      width: 6px;
      height: 6px;
      background: #ffffff;
      border-radius: 50%;
      position: absolute;
      box-sizing: content-box;
      top: 9px;
      left: 0;
    }
    i:hover {
      width: 8px;
      height: 8px;
      top: 8px;
      em {
        display: inherit;
      }
    }
    .i_active {
      border: 1px solid #007a9c;
    }
    em {
      position: fixed;
      max-width: 166px;
      min-width: 76px;
      height: auto;
      text-align: left;
      background: #008acf;
      border-radius: 9px;
      color: #ffffff;
      font-size: 18px;
      padding: 15px 20px;
      margin-top: -24px;
      margin-left: 4px;
      transform: translate(-50%, -100%);
      word-break: break-all;
      display: none;
      &::after {
        content: "";
        position: absolute;
        width: 0px;
        height: 0;
        left: 50%;
        margin-left: -8px;
        border: 8px solid #008acf;
        border-left: 8px solid transparent;
        border-top: 8px solid transparent;
        border-bottom-right-radius: 5px;
        transform: rotate(45deg);
        bottom: -7px;
      }
      &::before {
        content: "";
        position: absolute;
        width: 20px;
        height: 30px;
        left: 50%;
        margin-left: -10px;
        bottom: -27px;
      }
      img {
        width: 40px;
        position: absolute;
        left: 50%;
        top: 50%;
        margin: -20px 0 0 -20px;
      }
    }
  }
  .range {
    width: calc(100% + 22px);
    outline: none;
    -webkit-appearance: none; /*清除系统默认样式*/
    background: -webkit-linear-gradient(#008acf, #008acf) no-repeat, #333;
    background: -o-linear-gradient(#008acf, #008acf) no-repeat, #333;
    background: -moz-linear-gradient(#008acf, #008acf) no-repeat, #333;
    background: linear-gradient(#008acf, #008acf) no-repeat, #333;
    height: 3px; /*横条的高度*/
    pointer-events: none;
  }
  /*拖动块的样式*/
  .range::-webkit-slider-thumb {
    position: relative;
    z-index: 2;
    -webkit-appearance: none; /*清除系统默认样式*/
    height: 22px; /*拖动块高度*/
    width: 22px; /*拖动块宽度*/
    background: #008acf; /*拖动块背景*/
    border-radius: 50%; /*外观设置为圆形*/
    border: 8px solid #ffffff; /*设置边框*/
    box-shadow: 0 0 0 6px hsla(0, 0%, 100%, 0.5);
    pointer-events: auto;
  }
  .video-duration {
    padding-right: 10px;
    color: #ffffff;
    text-align: left;
  }
  .video-currentTime {
    width: 90px;
    color: #ffffff;
    text-align: right;
  }
  .rate {
    height: 32px;
    width: 64px;
    line-height: 32px;
    text-align: center;
    border: 1px solid #fff;
    border-radius: 16px;
    margin: 0 25px;
    font-size: 16px;
    color: #fff;
  }
  .vp-tap {
    width: 30px;
    height: 26px;
    margin-right: 27px;
  }
  .screenshots {
    width: 30px;
    height: auto;
    margin-right: 27px;
  }
}
.fade-enter-active {
  animation: fade 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.fade-leave-active {
  animation: fade 0.3s reverse cubic-bezier(0.645, 0.045, 0.355, 1);
}
.tk-enter-active {
  animation: answer-in .5s cubic-bezier(0.745, 0, 0.31, 0.995);
}
.tk-leave-active {
  animation: answer-out .5s cubic-bezier(0.745, 0, 0.31, 0.995);
}
.xz-enter-active {
  animation: answer-in .5s cubic-bezier(0.745, 0, 0.31, 0.995);
}
.xz-leave-active {
  animation: answer-out 0s .5s cubic-bezier(0.745, 0, 0.31, 0.995);
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/playback/playback.vue